







import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductTuple } from '@/stores/search/util';
import { Urls } from '@/util/Urls';

@Component
export default class ProductImage extends Vue {
  @Prop({required: true})
  private product!: ProductTuple;

  public get thumbnailUrl(): string {
    return Urls.thumbnailFor(this.product);
  }
}
